import models from './models.json';
import pages from './pages.json';
import text from './text.json';
import ui from './ui.json';

export const en = {
  translation: {
    ...models,
    ...pages,
    ...text,
    ...ui,
  },
};
